__turbopack_context__.v({
  "categories": "Encyclopedia-module-scss-module__uD4ufW__categories",
  "header": "Encyclopedia-module-scss-module__uD4ufW__header",
  "popular": "Encyclopedia-module-scss-module__uD4ufW__popular",
});
